const crypto = require("crypto");
const { sign } = require("jsonwebtoken");
const fs = require('fs');
const path = require('path');
const { sum } = require('mathjs');

function move_folder_recursive(source, destination) {
  if (!fs.existsSync(destination)) {
      fs.mkdirSync(destination, { recursive: true });
  }

  const files = fs.readdirSync(source);

  files.forEach((file) => {
      const sourcePath = path.join(source, file);
      const destPath = path.join(destination, file);
      if (fs.statSync(sourcePath).isDirectory()) {
        move_folder_recursive(sourcePath, destPath);
      } else {
          fs.renameSync(sourcePath, destPath);
      }
  });

  fs.rmdirSync(source);
}

function encode_md5(word) {
  const md5_hash = crypto.createHash("md5");
  return md5_hash.update(word).digest("hex");
}

function encode_email(word) {
  const hash_email = crypto.randomBytes(64).toString("hex");
  return hash_email;
}

function generateToken(data, expires_in) {
  const payload = { data: data };
  const options = { expiresIn: expires_in};
  return sign(payload, process.env.JWT_SECRET_TOKEN, options);
}

function safeSum(a, b) {
  return sum(a || 0, b || 0);
}

async function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

async function generateSustainfinityCode() {
  const tokens = [
    "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", 
    "A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "Z", "X", "C", 
    "V", "B", "N", "M", "Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"
  ];

  const fixedLength = 19;
  const tokensLength = tokens.length;

  let token = "";

  for (let index = 0; index < fixedLength; index++) {
    const randomIndex = await getRandomInt(0, tokensLength-1);
    
    if (token.length > 0) {
      token = token.split("");

      if (index === 4 || index === 9 || index === 14) {
        token.push("-");
      } else {
        token.push(tokens[randomIndex]);
      }

      token = token.join("");
    } else {
      token = tokens[randomIndex];
    }
  }

  return token;
}

async function recursiveStatSync(directory) {
  let size = 0;
  
  const files = fs.readdirSync(directory);
  
  for (const file of files) {
    const filePath = path.join(directory, file);
    const stats = fs.statSync(filePath);
    
    console.log(`Stats of ${file}: `, stats.size);
    if (stats.isDirectory()) {
      size += await recursiveStatSync(filePath);
    } else {
      size += stats.size;
    }
  }
  
  return size;
}

async function hashString(str) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}

module.exports = {
  encode_md5,
  encode_email,
  generateToken,
  move_folder_recursive,
  safeSum,
  generateSustainfinityCode,
  recursiveStatSync,
  hashString,
};